import { useRef, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { close_role_modal, set_role_modal } from '../../action/modals'
import { trans } from '../../utils/utilsTrans'
import ModalConfirm from '../UI/ModalConfirm'

const RoleSelect = (props) => {
  const {
    close_role_modal,
    set_role_modal,
    input,
    enableChangeRole,
    hasDelete,
    onDelete,
    blackListRoles,
  } = props
  let { currentRole, setCurrentRole } = props

  if (input) {
    currentRole = input.value
    setCurrentRole = input.onChange
  }

  const [isActive, setIsActive] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const buttonRef = useRef()

  const onSelect = (role) => {
    setCurrentRole(role)
    close_role_modal()
  }

  const openSelect = () => {
    const bounding = buttonRef.current.getBoundingClientRect()
    set_role_modal(
      [bounding.x, bounding.y],
      currentRole,
      onSelect,
      hasDelete,
      () => setIsDeleting(true),
      blackListRoles
    )
  }

  return (
    <>
      {isDeleting ? (
        <ModalConfirm
          title={trans('users.confirmation_delete_title')}
          text={trans('users.confirmation_delete_description')}
          isDanger={true}
          onConfirm={onDelete}
          closeModal={() => setIsDeleting(false)}
        />
      ) : null}
      <div className='relative w-fit' ref={buttonRef}>
        <button
          type='button'
          className={`inline-flex items-center space-x-2 px-2 py-4 rounded-8 transition-colors ${
            isActive
              ? 'bg-backgroundSecondary'
              : enableChangeRole
              ? 'hover:bg-backgroundPrimary'
              : ''
          } ${enableChangeRole ? 'cursor-pointer' : ''}`}
          onClick={enableChangeRole ? openSelect : null}
          onKeyDown={() => {}}
        >
          <span className='text-greyLight2 text-sm font-semibold'>
            {trans(`users.roles.${currentRole}.name`)}
          </span>
          {enableChangeRole ? (
            <i className='icon-chevron-down text-greyLight5' />
          ) : null}
        </button>
      </div>
    </>
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    ...bindActionCreators({ set_role_modal, close_role_modal }, dispatch),
  }
}

const mapStateToProps = (state) => {
  return {
    roleSelect: state.modals.roleSelect,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RoleSelect)
